export const getPageAccessUid = (state: any, id: String) => {
    const accessCrud = state.user.accessCrud.find((item: any) => item.uid === id);
    return accessCrud.page_access_uid
}